// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import InputWrapper from '../InputWrapper';

// Types
import { formikInjectedPropsTypes } from '../../../../../lib/validation/propTypes/formikPropTypes';

/**
 * @visibleName Numeric
 */
const InputNumeric = ({ className, ...props }) => (
  <InputWrapper
    {...props}
    type="tel"
    className={classnames('input-numeric', className)}
  />
);

InputNumeric.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  formikProps: formikInjectedPropsTypes.isRequired,
};

export default InputNumeric;
